import React, {Component} from 'react'
import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
  Grid,
  GridItem,
  HStack,
  Badge,
  Input,
  InputGroup,
  InputLeftElement,
  Icon,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  Card,
  CardBody,
  useBreakpointValue
} from '@chakra-ui/react';
import { FiSearch, FiMail, FiSend } from 'react-icons/fi';
import './Berichten.css'
import Sidebar from '../Sidebar/Sidebar';
import Navigation from '../../Navigation/Navigation';
import MobileMenu from '../MobileMenu/MobileMenu';
import Footer from '../../../components/Footer/Footer';

class Berichten extends Component {
  constructor(props) {
    super(props);
    // Initialize tab based on showSentTab flag
    const showSent = props.state.showSentTab;
    this.state = {
      isMobileMenuOpen: false,
      searchKeyword: '',
      tabIndex: showSent ? 1 : 0
    };
  }

  componentDidMount() {
    // Load messages when component mounts
    this.loadAllMessages();
  }

  componentDidUpdate(prevProps) {
    // If user changed (e.g., logout and login as different user), reset and reload
    if (prevProps.state.username !== this.props.state.username && this.props.state.username) {
      this.loadAllMessages();
      this.setState({ tabIndex: 0, searchKeyword: '' });
      return;
    }

    // Reload messages when navigating to this page
    if (this.props.state.route === 'berichten' && prevProps.state.route !== 'berichten') {
      this.loadAllMessages();

      // Check if we should show the sent tab (after sending a message)
      if (this.props.state.showSentTab) {
        this.setState({ tabIndex: 1 });
        // Clear the flag after using it
        if (this.props.onClearSentTabFlag) {
          this.props.onClearSentTabFlag();
        }
      } else if (prevProps.state.route === 'berichtInfo') {
        // Coming back from viewing a message - restore the tab we were on
        const lastTab = this.props.state.lastMessageTab || 'received';
        this.setState({ tabIndex: lastTab === 'sent' ? 1 : 0 });
      } else {
        // Navigating from menu or other pages - show received tab
        this.setState({ tabIndex: 0 });
      }
    }
  }

  loadAllMessages = async () => {
    if (this.props.loadMessages) {
      await this.props.loadMessages('received');
      await this.props.loadMessages('sent');
    }
  }

  handleSearchChange = (event) => {
    this.setState({ searchKeyword: event.target.value });
  }

  handleTabChange = (index) => {
    this.setState({
      tabIndex: index,
      searchKeyword: ''
    });
  }

  handleOpenMobileMenu = () => {
    this.setState({ isMobileMenuOpen: true })
  }

  handleCloseMobileMenu = () => {
    this.setState({ isMobileMenuOpen: false })
  }

  componentWillUnmount() {
    // Ensure mobile menu is closed when component unmounts
    if (this.state.isMobileMenuOpen) {
      this.setState({ isMobileMenuOpen: false })
    }
  }
  render () {
    const receivedMessages = this.props.state.messages.received;
    const sentMessages = this.props.state.messages.sent;
    const isFiltering = this.state.searchKeyword.trim().length > 0;

    // Apply search filter to the active tab's messages only
    const getFilteredMessages = (messages) => {
      if (!isFiltering || !messages || !messages.items) return messages;
      const searchLower = this.state.searchKeyword.toLowerCase();
      return {
        ...messages,
        items: messages.items.filter(message => {
          return (
            message.subject?.toLowerCase().includes(searchLower) ||
            message.text?.toLowerCase().includes(searchLower) ||
            message.sender_username?.toLowerCase().includes(searchLower) ||
            message.recipient_username?.toLowerCase().includes(searchLower)
          );
        })
      };
    };

    return (
      <>
        <Grid
        templateColumns="repeat(24, 1fr)"
        gap={0}
        minH="100vh"
        bg="gray.50"
        >
        <GridItem
        as="aside"
        colSpan={{ base: 0, md: 4, lg: 3 }} 
          display={{ base: "none", md: "block" }}
        bg="white"
        borderRight="1px solid"
        borderColor="gray.200"
        >
        <Sidebar
        state = {this.props.state}
        userVersion = {this.props.state.userVersion}
        onRouteChange = {this.props.onRouteChange}
        onLogout = {this.props.onLogout}
        />
        </GridItem>
        
        <GridItem
        as="main"
        colSpan={{ base: 24, md: 20, lg: 21 }}
        p="10px"
        display="flex"
        flexDirection="column"
        minHeight="100vh"
        >
        <Navigation
        state = {this.props.state}
        onRouteChange = {this.props.onRouteChange}
        getFeed = {this.props.getFeed}
        onVersionChange = {this.props.onVersionChange}
        onLogout = {this.props.onLogout}
        onOpenFeedback = {this.props.onOpenFeedback}
        onOpenMobileMenu = {this.handleOpenMobileMenu}
        />

        <Box p="40px" flex="1">
          <VStack spacing={6} align="stretch">
            <Heading as="h2" size="lg" textAlign="center" color="gray.600">
              Berichten
            </Heading>
            
            <Text color="gray.500" textAlign="center">
              Beheer uw ontvangen en verzonden berichten
            </Text>

            {/* Tabs for received/sent messages */}
            <Tabs
              variant="enclosed"
              colorScheme="blue"
              index={this.state.tabIndex}
              onChange={this.handleTabChange}
            >
              <TabList justifyContent="center">
                <Tab leftIcon={<FiMail />}>Ontvangen</Tab>
                <Tab leftIcon={<FiSend />}>Verzonden</Tab>
              </TabList>

              <TabPanels>
                <TabPanel>
                  {this.renderMessageList('received', getFilteredMessages(receivedMessages), isFiltering)}
                </TabPanel>
                <TabPanel>
                  {this.renderMessageList('sent', getFilteredMessages(sentMessages), isFiltering)}
                </TabPanel>
              </TabPanels>
            </Tabs>

          </VStack>
        </Box>
        <Footer onRouteChange={this.props.onRouteChange} />

        </GridItem>
        </Grid>

        {/* Mobile Menu Drawer */}
        <MobileMenu
          isOpen={this.state.isMobileMenuOpen}
          onClose={this.handleCloseMobileMenu}
          onRouteChange={this.props.onRouteChange}
          userVersion={this.props.state.userVersion}
          resetSuggestionsPage={this.props.resetSuggestionsPage}
          onLogout={this.props.onLogout}
        />
      </>
    )
  }

  renderMessageList = (type, messages, isFiltering) => {
    return (
      <VStack spacing={4} align="stretch">
        {/* Search Filter */}
        {messages && messages.items && messages.items.length > 0 && (
          <Box maxWidth="400px" mx="auto">
            <InputGroup>
              <InputLeftElement pointerEvents="none">
                <Icon as={FiSearch} color="gray.400" />
              </InputLeftElement>
              <Input
                placeholder="Zoek berichten..."
                value={this.state.searchKeyword}
                onChange={this.handleSearchChange}
                bg="white"
                borderRadius="md"
                shadow="sm"
              />
            </InputGroup>
            {isFiltering && (
              <Text fontSize="sm" color="gray.600" mt={2} textAlign="center">
                {messages.items.length} resultaten gevonden voor "{this.state.searchKeyword}"
              </Text>
            )}
          </Box>
        )}
        
        {messages && messages.items && messages.items.length > 0 ? (
          <>
            {/* Card view for all screen sizes */}
            <VStack spacing={3} align="stretch">
              {messages.items.map((message, index) => (
                <MessageCard
                  key={message.id || index}
                  message={message}
                  type={type}
                  onMessageSelect={(msg) => this.props.onMessageSelect && this.props.onMessageSelect(msg, type)}
                  onMarkAsRead={this.props.onMarkMessageAsRead}
                  isMobile={this.props.isMobile}
                />
              ))}
            </VStack>
            
            {/* Pagination - only show when not filtering */}
            {!isFiltering && (messages.hasNext || messages.hasPrev || messages.page > 0) && (
              <Box textAlign="center" mt={6}>
                <HStack justify="center" spacing={4}>
                  <Button
                    disabled={!messages.hasPrev}
                    onClick={() => this.props.onPaginationButtonClick && this.props.onPaginationButtonClick('Previous', `messages_${type}`)}
                    bg="blue.400"
                    color="white"
                    _hover={{ bg: 'blue.500' }}
                    _disabled={{ bg: 'gray.300', color: 'gray.500', cursor: 'not-allowed' }}
                  >
                    Vorige
                  </Button>
                  <Text color="gray.500">
                    Pagina {messages.page + 1}
                  </Text>
                  <Button
                    disabled={!messages.hasNext}
                    onClick={() => this.props.onPaginationButtonClick && this.props.onPaginationButtonClick('Next', `messages_${type}`)}
                    bg="blue.400"
                    color="white"
                    _hover={{ bg: 'blue.500' }}
                    _disabled={{ bg: 'gray.300', color: 'gray.500', cursor: 'not-allowed' }}
                  >
                    Volgende
                  </Button>
                </HStack>
              </Box>
            )}
          </>
        ) : (
          <Box textAlign="center" py={12}>
            <Icon as={FiMail} w={16} h={16} color="gray.300" mb={4} />
            <Heading as="h3" size="md" color="gray.500" mb={2}>
              Geen berichten
            </Heading>
            <Text color="gray.400">
              {type === 'received' ? 'U heeft nog geen berichten ontvangen.' : 'U heeft nog geen berichten verzonden.'}
            </Text>
          </Box>
        )}
      </VStack>
    );
  }
}

// Card Component for Messages (all screen sizes)
class MessageCard extends Component {
  handleMarkAsRead = () => {
    if (this.props.onMarkAsRead && !this.props.message.is_read) {
      this.props.onMarkAsRead(this.props.message.id);
    }
  }

  render() {
    const { message, type } = this.props;

    return (
      <Card
        w="100%"
        bg={!message.is_read && type === 'received' ? 'blue.50' : 'white'}
        shadow="sm"
        _hover={{ shadow: 'md' }}
        transition="all 0.2s"
        borderLeft={!message.is_read && type === 'received' ? '4px solid' : 'none'}
        borderLeftColor={!message.is_read && type === 'received' ? 'blue.400' : 'transparent'}
      >
        <CardBody>
          {this.props.isMobile ? (
            <VStack align="stretch" spacing={3}>
              {/* Header: From/To and Status */}
              <HStack justify="space-between" w="100%">
                <Text
                  fontWeight={!message.is_read && type === 'received' ? "bold" : "semibold"}
                  color="gray.700"
                  fontSize="sm"
                >
                  {type === 'received' ? `Van: ${message.sender_username}` : `Naar: ${message.recipient_username}`}
                </Text>
                {type === 'received' && (
                  <Badge
                    colorScheme={message.is_read ? 'gray' : 'blue'}
                    variant="solid"
                    fontSize="xs"
                  >
                    {message.is_read ? 'Gelezen' : 'Nieuw'}
                  </Badge>
                )}
                {type === 'sent' && (
                  <Badge colorScheme="green" variant="solid" fontSize="xs">
                    Verzonden
                  </Badge>
                )}
              </HStack>

              {/* Subject */}
              <Text
                color="blue.600"
                fontSize="sm"
                fontWeight={!message.is_read && type === 'received' ? "bold" : "semibold"}
                noOfLines={2}
                cursor="pointer"
                _hover={{ color: 'blue.800' }}
                onClick={() => this.props.onMessageSelect && this.props.onMessageSelect(message)}
              >
                {message.subject}
              </Text>

              {/* Date */}
              <Text fontSize="xs" color="gray.500">
                {message.created_at ?
                  new Date(message.created_at).toLocaleDateString('nl-NL', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  }) :
                  'Onbekend'}
              </Text>

              {/* Actions */}
              <HStack spacing={2} w="100%">
                <Button
                  size="sm"
                  colorScheme="blue"
                  variant="outline"
                  onClick={() => this.props.onMessageSelect && this.props.onMessageSelect(message)}
                  flex={1}
                >
                  Bekijken
                </Button>
                {type === 'received' && !message.is_read && (
                  <Button
                    size="sm"
                    colorScheme="gray"
                    onClick={this.handleMarkAsRead}
                    flex={1}
                  >
                    Markeer als gelezen
                  </Button>
                )}
              </HStack>
            </VStack>
          ) : (
            /* Desktop: Horizontal layout */
            <VStack align="stretch" spacing={3}>
              {/* Header Row: From/To, Date, Status */}
              <HStack justify="space-between" w="100%">
                <HStack spacing={4}>
                  <Text
                    fontWeight={!message.is_read && type === 'received' ? "bold" : "semibold"}
                    color="gray.700"
                    fontSize="sm"
                  >
                    {type === 'received' ? `Van: ${message.sender_username}` : `Naar: ${message.recipient_username}`}
                  </Text>
                  <Text fontSize="sm" color="gray.500">
                    {message.created_at ?
                      new Date(message.created_at).toLocaleDateString('nl-NL', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                      }) :
                      'Onbekend'}
                  </Text>
                </HStack>
                <HStack spacing={3}>
                  {type === 'received' && (
                    <Badge
                      colorScheme={message.is_read ? 'gray' : 'blue'}
                      variant="solid"
                      fontSize="xs"
                    >
                      {message.is_read ? 'Gelezen' : 'Nieuw'}
                    </Badge>
                  )}
                  {type === 'sent' && (
                    <Badge colorScheme="green" variant="solid" fontSize="xs">
                      Verzonden
                    </Badge>
                  )}
                  <Button
                    size="sm"
                    colorScheme="blue"
                    variant="outline"
                    onClick={() => this.props.onMessageSelect && this.props.onMessageSelect(message)}
                  >
                    Bekijken
                  </Button>
                  {type === 'received' && !message.is_read && (
                    <Button
                      size="sm"
                      colorScheme="gray"
                      onClick={this.handleMarkAsRead}
                    >
                      Markeer als gelezen
                    </Button>
                  )}
                </HStack>
              </HStack>

              {/* Subject */}
              <Text
                color="blue.600"
                fontSize="md"
                fontWeight={!message.is_read && type === 'received' ? "bold" : "semibold"}
                noOfLines={2}
                cursor="pointer"
                _hover={{ color: 'blue.800', textDecoration: 'underline' }}
                onClick={() => this.props.onMessageSelect && this.props.onMessageSelect(message)}
              >
                {message.subject}
              </Text>
            </VStack>
          )}
        </CardBody>
      </Card>
    );
  }
}

// Wrapper to inject breakpoint value into class component
function BerichtenWrapper(props) {
  const isMobile = useBreakpointValue({ base: true, md: false });
  return <Berichten {...props} isMobile={isMobile} />;
}

export default BerichtenWrapper
